// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3724":"VoltoFormBlockEdit","4328":"Widgets","4776":"VoltoFormBlockView","5092":"InnerMap","9824":"GDPRCookieSettingsWidget"}[chunkId] + "." + {"3724":"05bf0964","4328":"99554e95","4776":"0b6464b2","5092":"98d6a562","9824":"1439b689"}[chunkId] + ".chunk.css";
};